import React, {useState, useEffect, ReactNode} from 'react';
import { Modal, Button } from 'react-daisyui';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ActivateStudyConfirmModalProps {
  isOpen: boolean;
  closeModal: () => void;
  handleStudyActivation: () => void;
  content?: ReactNode
  studies: any
  taskStatueses?: any
  activateStudyId?: number | undefined
  error?: boolean;
  timeLimitExceeded?: boolean;
  taskPollingStatus?: boolean;
}

const ActivateStudyConfirmModal: React.FC<ActivateStudyConfirmModalProps> = ({
  isOpen,
  closeModal,
  handleStudyActivation,
  content,
  studies,
  taskStatueses,
  activateStudyId,
  error, 
  timeLimitExceeded,
  taskPollingStatus
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //reset loading
    isOpen && setLoading(false);
  }, [isOpen])
  

  useEffect(() => {
    //
    taskStatueses && activateStudyId && taskStatueses[activateStudyId]?.task?.status === "STARTED" && setLoading(true)
    //taskStatueses && activateStudyId && taskStatueses[activateStudyId]?.created.state && !taskStatueses[activateStudyId]?.active.state && setLoading(true)
    taskStatueses && activateStudyId && taskStatueses[activateStudyId]?.task?.status === "FAILURE" && setLoading(false)
    taskStatueses && activateStudyId && taskStatueses[activateStudyId]?.task?.status === "PENDING" && setLoading(true)
    taskPollingStatus && setLoading(false)  
  }, [error, taskStatueses, activateStudyId, taskPollingStatus])
  
  const handleConfirm = () => {
    setLoading(true);
    handleStudyActivation();
  };

  return (
    <div className="font-sans">
      <Modal open={isOpen}>
        {/* <Modal.Header className="font-bold">
         Please click on "Confirm" to activate the study. This will automatically generate a survey in Limesurvey and initiate the process.
        </Modal.Header> */}

        <Modal.Body>
          <div>
            Please click on "Confirm" to activate the study. This will
            automatically generate a survey in Limesurvey and initiate the
            process.
          </div>
          
            <div className="mt-4">
            {loading && (
              <>
                <p className="text-red-500">Processing...</p>
                {/* <p className="text-sm text-gray-500">
                  Please do not close the browser while processing.
                </p> */}
              </>
              )}
              {content}
            </div>
          
        </Modal.Body>

        <Modal.Actions>
          <Button id='ModalCancelButton' type='button' onClick={closeModal}>
            {!loading ? 'Cancel' : 'Close'}
          </Button>

        {!timeLimitExceeded && ( // timelimitexceed error will need to be handled by dev team(e.g. remove the study in django web app), therefore no retry for the process
          <Button
            id='ModalConfirmButton'
            type='button'
            color="primary"
            className={loading ? "pointer-events-none" : ""} // Disable button while processing
            onClick={loading ? undefined : handleConfirm} // If processing, do nothing
          >
            {loading ? (
              <div className="flex items-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Loading...
              </div>
            ) : (
              error || taskPollingStatus ? "Retry" : "Confirm"
            )}
          </Button>
          )}
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ActivateStudyConfirmModal;
